import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  BaseRendererComponent,
  FormService,
  IdDescription,
  LocationReferenceService,
  ModalService,
  UtilityService,
} from 'tms-lib';
import { StockItemHeaderReceiptService } from '../../../../services';

@Component({
  selector: 'app-location-select-renderer',
  templateUrl: './location-select-renderer.component.html',
  styleUrl: './location-select-renderer.component.scss',
})
export class LocationSelectRendererComponent extends BaseRendererComponent implements OnInit, ICellRendererAngularComp {
  static warehouseIdChanged = new Subject<number>();

  private modalLevel: number;

  constructor(
    private locationReferenceService: LocationReferenceService,
    private stockItemHeaderReceiptService: StockItemHeaderReceiptService,
    private utilityService: UtilityService,
    private formService: FormService,
    private modalService: ModalService,
  ) {
    super();
  }

  ngOnInit() {
    this.modalLevel = this.modalService.modalLevel;
    this.monitorWarehouseId();
  }

  public onChange(event: any) {
    this.params.node.setDataValue(this.colId, event.value);
    if (this.isAggregate) return;

    switch (this.colId) {
      case 'warehouseId':
        LocationSelectRendererComponent.warehouseIdChanged.next(this.rowIndex);
        break;
      case 'locationId':
        this.stockItemHeaderReceiptService
          .amendStockAlreadyReceived(this.rowData)
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => this.formService.resetForms(this.modalLevel));
        break;
    }
  }

  private monitorWarehouseId() {
    if (this.colId == 'locationId' && !this.isAggregate) {
      LocationSelectRendererComponent.warehouseIdChanged
        .pipe(takeUntil(this.destroy$))
        .subscribe((rowIndex: number) => {
          if (rowIndex === this.rowIndex) {
            this.locationReferenceService
              .getForWarehouse(this.rowData.warehouseId)
              .pipe(takeUntil(this.destroy$))
              .subscribe((locations: IdDescription[]) => {
                this.params.context.options = this.utilityService.mapSelectOptions(locations);
                if (!locations.find((x) => x.id === this.cellData)) {
                  this.setDataValue(this.colId, undefined);
                }
              });
          }
        });

      LocationSelectRendererComponent.warehouseIdChanged.next(this.rowIndex);
    }
  }
}
